var render = function render(){var _vm=this,_c=_vm._self._c;return _c('predicate-list',_vm._g(_vm._b({attrs:{"filterable-fields":_vm.filterableFields}},'predicate-list',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }